import './_wall.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Wall = ({ children, rounded }) => <div className={classNames('services-wall', { 'services-wall-rounded': rounded })}>{children}</div>;

Wall.propTypes = {
  children: PropTypes.object,
  rounded: PropTypes.bool,
};
export default Wall;
